import React from "react";

interface OdxAreaHeaderProps extends React.HTMLProps<HTMLDivElement> {
    text: string | React.ReactNode,
    subTitle?: string | React.ReactNode,
    odxSize?: 'small' | 'medium' | 'large';
    odxContent?: React.ReactNode;
    className?: string;
}

/** Usage
 * <OdxAreaHeader
 *           odxSize={'medium'}
 *           text={'All Projects'}
 *           odxContent={
 *             <OdxButton
 *               variant={odxVariants.highlight}
 *               type={'button'}
 *               odxSize={'medium'}
 *               text={'Add new project'}
 *               odxIcon={<OdxIcon iconSet={odxIconSets.core} size={'md'} name={'plus'} />}
 *             ></OdxButton>
 *           }
 *           className={'pl-0'}
 *         />
 */


/**
 * Area header component. Is used to display a header with a title and subtitle.
 * @param text The title of the header.
 * @param subTitle The subtitle of the header.
 * @param odxSize The size of the header. Can be 'small', 'medium' or 'large'.
 * @param odxContent React node to display buttons in the header.
 * @param className Additional classes to apply to the header.
 * @param rest Additional props to apply to the header.
 * @constructor
 */
const OdxAreaHeader = ({text, subTitle, odxSize = "medium", odxContent, className, ...rest}: OdxAreaHeaderProps) => {
    return (
        <div className={`odx-area-header--${odxSize} odx-area-header ${className}`}>
            <div className="odx-area-header__container">
                <div className="odx-area-header__inner">
                    <div className="odx-area-header__title">
                        {text}
                    </div>
                    <div className={"odx-area-header__subtitle"}>
                        {subTitle}
                    </div>
                </div>
            </div>
            <div className="odx-area-header__content">
                <odx-button-group variant={"accent"} size="lg">
                    {odxContent}
                </odx-button-group>
            </div>
        </div>
    )
}

export default OdxAreaHeader;
